
// ==================== دالة مساعدة لتنسيق التاريخ ====================
export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;
  const day = date.getDate();
  const month = date.toLocaleDateString('en-US', { month: 'short' });
  const year = date.getFullYear();
  return `${day} ${month}, ${year}`;
};

// ==================== دالة مساعدة لتنسيق الوقت ====================
export const formatTime = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });
};

// ==================== جلب جميع الفواتير من API ====================
export const fetchInvoices = async () => {
  try {
    const token = localStorage.getItem('auth_token');
    
    if (!token) {
      throw new Error('يجب تسجيل الدخول أولاً');
    }

    // ✅ جلب الصفحة الأولى
    const response1 = await fetch(`https://emiratesscholar.com/system/api/user-payments-list?page=1&_t=${Date.now()}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
      },
    });

    if (!response1.ok) {
      throw new Error('فشل جلب الفواتير');
    }

    const text1 = await response1.text();
    if (text1.startsWith('<!DOCTYPE') || text1.startsWith('<html')) {
      throw new Error('الخادم أرجع HTML');
    }

    const data1 = JSON.parse(text1);
    const allPayments = [...(data1?.paymentsList?.data || [])];

    // ✅ جلب الصفحة الثانية إذا وجدت
    if (data1?.paymentsList?.last_page > 1) {
      const response2 = await fetch(`https://emiratesscholar.com/system/api/user-payments-list?page=2&_t=${Date.now()}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
        },
      });

      if (response2.ok) {
        const text2 = await response2.text();
        const data2 = JSON.parse(text2);
        allPayments.push(...(data2?.paymentsList?.data || []));
      }
    }

    console.log('✅ [fetchInvoices] تم جلب', allPayments.length, 'فاتورة');

    // ✅ قراءة الفواتير المدفوعة محلياً من localStorage لتحديث الحالة
    let paidInvoices = [];
    try {
      paidInvoices = JSON.parse(localStorage.getItem('paid_invoices') || '[]');
      if (!Array.isArray(paidInvoices)) {
        paidInvoices = [];
      }
    } catch (e) {
      console.warn('Error reading paid_invoices from localStorage', e);
    }

    // ✅ تحويل البيانات إلى الشكل المطلوب
    const invoices = allPayments.map(payment => {
      const isPaidLocal = paidInvoices.includes(payment?.id?.toString()) || 
                          (payment?.invoice_no && paidInvoices.includes(payment.invoice_no.toString()));
      const statusStr = String(payment?.status || '').trim().toLowerCase();
      const status = (statusStr === 'paid' || statusStr === 'success' || isPaidLocal) ? 'paid' : 'pending';
      const paidOn = (status === 'paid') 
        ? formatDate(payment?.updated_at || new Date().toISOString()) 
        : null;

      return {
        id: payment?.id?.toString() || '—',
        grpId: payment?.grp_id || payment?.id?.toString() || '—',
        invoiceNo: payment?.invoice_no || '—',
        desc: payment?.addon_title || payment?.event_name || 'No description',
        pkg: payment?.ticket_number 
          ? `${payment.event_acronym || 'Ticket'} ${payment.ticket_number}`
          : payment?.event_acronym || 'N/A',
        date: formatDate(payment?.created_at),
        time: formatTime(payment?.created_at),
        amt: `$${parseFloat(payment?.amount || 0).toFixed(2)}`,
        amtNum: parseFloat(payment?.amount || 0),
        status: status,
        paidOn: paidOn,
        billTo: {
          name: 'User',
          phone: '',
          email: '',
          country: '',
          company: ''
        },
        event: {
          name: payment?.event_name || 'N/A',
          date: formatDate(payment?.created_at),
          ticketId: payment?.ticket_number || 'N/A'
        },
        items: [
          {
            id: 1,
            name: payment?.addon_title || 'Item',
            desc: payment?.event_acronym || '',
            qty: payment?.addon_qty || 1,
            price: parseFloat(payment?.addon_price || 0)
          }
        ],
        payments: (payment?.status === 'Paid' || isPaidLocal) ? [
          {
            reference: payment?.invoice_no || '',
            amount: `$${parseFloat(payment?.amount || 0).toFixed(2)}`,
            date: paidOn || formatDate(new Date().toISOString()),
            transactionId: payment?.grp_id || ('MOCK_' + Math.random().toString(36).substr(2, 9).toUpperCase())
          }
        ] : [],
        totals: {
          subTotal: parseFloat(payment?.addon_total || payment?.amount || 0),
          discount: 0.00,
          processingFees: 0.00,
          handlingFees: 0.00,
          vat: 0.00,
          grandTotal: parseFloat(payment?.amount || 0)
        },
        // ✅ البيانات الأصلية للحاجة
        raw: payment
      };
    });

    // ✅ الإحصائيات
    const stats = {
      total: invoices.length,
      paid: invoices.filter(i => i.status === 'paid').length,
      pending: invoices.filter(i => i.status === 'pending').length,
      totalSpending: invoices.reduce((sum, i) => sum + i.amtNum, 0)
    };

    console.log('✅ [fetchInvoices] الإحصائيات:', stats);

    return { invoices, stats };

  } catch (error) {
    console.error('❌ [fetchInvoices] خطأ:', error);
    throw error;
  }
};

// ==================== جلب فاتورة واحدة ====================
export const fetchInvoiceById = async (id) => {
  try {
    const token = localStorage.getItem('auth_token');
    
    if (!token) {
      throw new Error('يجب تسجيل الدخول أولاً');
    }

    // ✅ جلب كل الفواتير والبحث عن المطلوب
    const { invoices } = await fetchInvoices();
    const invoice = invoices.find(inv => inv.id === id);
    
    if (!invoice) {
      throw new Error('الفاتورة غير موجودة');
    }

    return invoice;

  } catch (error) {
    console.error('❌ [fetchInvoiceById] خطأ:', error);
    throw error;
  }
};

export const deleteInvoice = async (grpId) => {
  try {
    const token = localStorage.getItem('auth_token');
    if (!token) {
      throw new Error('No auth token found');
    }
    const response = await fetch(`https://emiratesscholar.com/system/api/delete-payment/${grpId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to delete invoice');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('❌ [deleteInvoice] Failed to delete invoice:', error);
    throw error;
  }
};